import { render, staticRenderFns } from "./downloadList8.vue?vue&type=template&id=4298f3a6&scoped=true"
import script from "./downloadList8.vue?vue&type=script&lang=js"
export * from "./downloadList8.vue?vue&type=script&lang=js"
import style0 from "./downloadList8.vue?vue&type=style&index=0&id=4298f3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298f3a6",
  null
  
)

export default component.exports